.active-batch {
  max-width: 120px;
}

.order-details-shipment-details-add-to-batch-dropdown {
  border: 1px solid var(--default--border-color--12);
}
